var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex align-items-end"},[_c('h4',[_vm._v("Preguntas de la denuncia")]),_c('div',{staticClass:"flex-grow-1"}),_c('SettingTypeDenounce')],1),_c('hr'),_c('SettingListQuestions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }